import React from 'react';
import { Check } from 'lucide-react';
import { Language } from '../contexts/LanguageContext';

// Ventanita emergente con lo que incluye cada paquete. Se usa en el formulario de pedido
// (pages/PedidoPage.tsx): aparece debajo del paquete cuando el cliente pasa el cursor por
// encima o lo enfoca con el teclado. En el celular no hay cursor, así que no se muestra.
// Los tres paquetes incluyen lo mismo (cambia solo cuántas personas cubre). EN/ES
// finalizados; HT/VI = mejor esfuerzo, pendiente de revisión nativa.
// 2026-10-18: se quitó la línea "la misma lista de pasos también en audio" (ese audio no existe).
// 2026-10-18: se agregó "Video explicativo paso a paso" (video "¿Cómo llenar su cheque?" ya creado).
// 2026-10-23: el plazo pasó de "24–48 horas" a "menos de 24 horas" (decisión de Manuel).
// Mantener igual que components/Pricing.tsx.
const INCLUDES: Record<Language, {
  title: string;
  items: string[];
}> = {
  es: {
    title: 'Cada paquete incluye:',
    items: ['Guiado por teléfono, WhatsApp o en línea — en su idioma', 'Revisión automática de errores y de que esté completo', 'Revisado personalmente por un especialista de Noor', 'Todos los formularios que su caso necesite — sin costo adicional', 'Paquete impreso a color y enviado a su casa', 'Una lista de los pasos a seguir, incluida junto con su formulario', 'Video explicativo paso a paso', 'Listo en menos de 24 horas', 'Sirve para cualquier formulario de pasaporte (nuevo, renovación, menor, perdido)']
  },
  en: {
    title: 'Every package includes:',
    items: ['Guided by phone, WhatsApp, or online — in your language', 'Automatic error & completeness check', 'Reviewed personally by a Noor specialist', 'Every form your case needs — at no extra cost', 'Color-printed packet mailed to your home', 'A checklist of the steps to follow, included with your form', 'Step-by-step explainer video', 'Ready in less than 24 hours', 'Works for any passport form (new, renewal, minor, lost)']
  },
  ht: {
    title: 'Chak pakè gen ladan:',
    items: ['Gidans pa telefòn, WhatsApp, oswa sou entènèt — nan lang ou', 'Tcheke otomatik pou erè ak pou wè si li konplè', 'Yon espesyalis Noor tcheke li pèsonèlman', 'Tout fòm ka ou a bezwen — san frè anplis', 'Pakè enprime an koulè voye lakay ou', 'Yon lis etap pou swiv, enkli ansanm ak fòm ou an', 'Videyo eksplikatif etap pa etap', 'Pare nan mwens pase 24 èdtan', 'Mache pou nenpòt fòm paspò (nouvo, renouvèlman, minè, pèdi)']
  },
  vi: {
    title: 'Mỗi gói bao gồm:',
    items: ['Hướng dẫn qua điện thoại, WhatsApp hoặc trực tuyến — bằng ngôn ngữ của quý vị', 'Tự động kiểm tra lỗi và tính đầy đủ', 'Được chuyên viên Noor đích thân xem lại', 'Mọi mẫu đơn trường hợp của quý vị cần — không tính thêm phí', 'Bộ hồ sơ in màu gửi đến nhà quý vị', 'Một danh sách các bước cần làm, kèm theo mẫu đơn của quý vị', 'Video hướng dẫn từng bước', 'Sẵn sàng trong vòng chưa đầy 24 giờ', 'Dùng cho mọi mẫu đơn hộ chiếu (mới, gia hạn, trẻ vị thành niên, bị mất)']
  }
};

// Debe ir dentro de un elemento con las clases "relative group".
export function PlanTip({
  language
}: {
  language: Language;
}) {
  const t = INCLUDES[language];
  return <span role="tooltip" aria-hidden="true" className="hidden md:group-hover:block md:group-focus-within:block absolute left-0 right-0 top-full mt-2 z-30 pointer-events-none rounded-2xl shadow-2xl border border-white/10 px-5 py-4 text-left" style={{
    background: '#172B4D'
  }} data-id="element-339" data-mp="yfsyar3xm0tj">
      <span className="block text-xs font-semibold uppercase tracking-wide mb-3" style={{
      color: '#E8B45A'
    }} data-id="element-340" data-mp="1cftwtzwq4w5u">
        {t.title}
      </span>
      <span className="grid sm:grid-cols-2 gap-x-6 gap-y-2" data-id="element-341" data-mp="2juf3k3o0px4w">
        {t.items.map((item, i) => <span key={i} className="flex items-start gap-2 text-[13px] leading-snug text-gray-100" data-id="element-342" data-mp="2nw0nua2vtdp4" data-mpi={i}>
            <Check className="w-3.5 h-3.5 mt-0.5 flex-shrink-0" style={{
          color: '#E8B45A'
        }} data-id="element-343" data-mp="2mev26c8mgixh" />
            <span data-id="element-344" data-mp="2hfs6hiej7p26">{item}</span>
          </span>)}
      </span>
    </span>;
}